import React from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  const phoneNumber = '447300405045';
  const message = encodeURIComponent("Hi, I'm interested in getting a quote from Expert Property Maintenance for property maintenance work.");
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  // Only show floating button on desktop - mobile uses MobileActionBar
  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="hidden md:flex fixed bottom-6 right-6 z-40 bg-[#25D366] hover:bg-[#128C7E] text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 group items-center justify-center"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-btn"
    >
      <MessageCircle className="w-7 h-7 fill-current" />
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-brand-navy text-white text-sm px-3 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Chat with us
      </span>
    </a>
  );
};

export default WhatsAppButton;
